import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const saveProjectBridgeChangeCriticality = api(async function saveProjectBridgeChangeCriticality({
    id,
    changeId,
    criticality,
}) {
    return mutate(
        gql`
            mutation SaveProjectBridgeChangeCriticality($id: ID!, $changeId: String!, $criticality: String) {
                saveProjectBridgeChangeCriticality(id: $id, changeId: $changeId, criticality: $criticality)
            }
        `,
        { id, changeId, criticality },
        { returns: "saveProjectBridgeChangeCriticality" }
    )
})
